module.exports = __webpack_public_path__ + "static/media/bread-loaf.c0870604.svg";